module.exports = __webpack_public_path__ + "media/6.2b79f4e0.mp3";